<template>
  <div>

    <van-checkbox-group @change="checkBoxChange" class="group-margin" v-model="isAgree">
      <van-checkbox name="a" icon-size="19px" >
        <div class="contract">
          <span>我已阅读并同意</span>
          <template>
            <span v-for="(item,index) in list" :key="item.id" >
              <span class="contract-span" @click.stop="openPopup(item.content)">《{{ item.title }}》</span>
              <span v-if="list.length != (index+1)" >和</span>
            </span>
          </template>
        </div>
      </van-checkbox>
    </van-checkbox-group>


    <van-popup
        v-model="popup_show"
        closeable
        position="bottom"
        style="height: 100vh;">
      <div class="text">
        <div>
<!--          <p class="title">版权声明</p>-->
          <div v-html="userAgreementContent"></div>

        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Agreement",
  data() {
    return {
      isAgree: [],
      list: [],
      popup_show: false,
      userAgreementContent: null,
      agreementIdList: []
    }
  },
  created() {
    this.getAgreement(this.agreementType);
  },
  mounted() {

  },
  methods: {
    getAgreement(e) {
      this.$get("agreement",{type: e})
        .then(res => {
          console.log(res);

          this.list = res.data;

          res.data.forEach(item => {
            this.agreementIdList.push(item.id);
          })

        })
    },
    checkBoxChange(e) {

      this.$emit('update:isAgree', e);

      if(e.length != 0) {
        this.$emit('update:agreementIdList', this.agreementIdList);
      }else {
        this.$emit('update:agreementIdList', []);
      }

    },
    openPopup(e) {

      this.userAgreementContent= e;
      this.popup_show= true;

    }
  },
  props: ["agreementType"]
}
</script>

<style lang="scss" scoped>
.van-checkbox{
  align-items: flex-start;
}
.group-margin{
  margin-top: 3.375rem;
  .contract{
    text-align: center;
    color: #888888;
    &-span{
      color: #3B9CFD;
    }
  }
}
.text{
  padding: 1rem 0.9375rem 0.625rem;
  line-height: 1.5rem;
  .title{
    text-align: center;
    font-weight: bold;
    font-size: 1.25rem;
    margin-bottom: 0.625rem;
  }
}
</style>
